module.exports = __webpack_public_path__ + "img/16581304_S.47fd3d4e.png";